import { ISearchInput } from '../types';
import { useBootstrapSelector } from '../../../../redux/selectorHooks';
import { assertNotNil } from '../../../../utils/types';
import AdvancedSearchMenuOption from './AdvancedSearchMenuOption';
import * as AdvancedSearchMenuUI from './AdvancedSearchMenuUI';
import { IconWrapper, SvgIcon } from '../../../../components/Icon';
import { AdvancedSearchDisabledSchemas } from './AdvancedSearchDisabledSchemas';
import { useMemo } from 'react';
import { theme } from '../../../../styles/theme';

interface IProps {
  searchInput: ISearchInput;
  setSearchInput: (searchInput: ISearchInput, isLoadMore: boolean) => void;
}

const SchemaSearchOption = ({ searchInput, setSearchInput }: IProps) => {
  const schemaConfig = useBootstrapSelector('schemaConfig');
  assertNotNil(schemaConfig);
  const schemaClickHandler = (schemaId: string) => {
    if (searchInput.schemaIds.includes(schemaId)) {
      setSearchInput(
        {
          ...searchInput,
          schemaIds: searchInput.schemaIds.filter((id) => id !== schemaId),
        },
        false,
      );
    } else {
      setSearchInput(
        {
          ...searchInput,
          schemaIds: [...searchInput.schemaIds, schemaId],
        },
        false,
      );
    }
  };

  const handleIncludeDisabledChange = () => {
    if (searchInput.activeSchemas) {
      setSearchInput({ ...searchInput, activeSchemas: false }, false);
    } else {
      // the action excludes the disabled then filter out the disabled schemas
      const schemaIds = searchInput.schemaIds.filter((id) =>
        schemaConfig.schemas.some((s) => s.id === id),
      );
      setSearchInput({ ...searchInput, schemaIds, activeSchemas: true }, false);
    }
  };

  const schemas = searchInput.activeSchemas
    ? schemaConfig.schemas
    : schemaConfig.allSchemas;

  // disable the switch when all schemas are active
  const disableSearchDisabledSchemas = useMemo(() => {
    if (schemaConfig.allSchemas.length !== schemaConfig.schemas.length) {
      return false;
    }

    return schemaConfig.allSchemas.every((s) =>
      schemaConfig.schemas.some((s2) => s2.id === s.id),
    );
  }, [schemaConfig.allSchemas, schemaConfig.schemas]);

  return (
    <AdvancedSearchMenuUI.SectionContainer>
      <AdvancedSearchMenuUI.SectionHeading>
        Schema
      </AdvancedSearchMenuUI.SectionHeading>
      <AdvancedSearchDisabledSchemas
        onClick={handleIncludeDisabledChange}
        checked={!searchInput.activeSchemas}
        disabled={disableSearchDisabledSchemas}
      />
      {schemas.map((schema) => (
        <AdvancedSearchMenuOption
          key={schema.id}
          onClick={() => schemaClickHandler(schema.id)}
          checked={searchInput.schemaIds.includes(schema.id)}
        >
          {schema.name}
          {schema.disabled && (
            <IconWrapper size={14}>
              <SvgIcon
                name="disconnected"
                customFill={theme.colors.secondary400}
              />
            </IconWrapper>
          )}
        </AdvancedSearchMenuOption>
      ))}
    </AdvancedSearchMenuUI.SectionContainer>
  );
};

export default SchemaSearchOption;
